import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { EditorPaneDescriptor } from 'vscode/vscode/vs/workbench/browser/editor';
import { RuntimeExtensionsEditor } from './browserRuntimeExtensionsEditor.js';
import { RuntimeExtensionsInput } from '../common/runtimeExtensionsInput.js';
import { EditorExtensions } from 'vscode/vscode/vs/workbench/common/editor';

const _moduleId = "vs/workbench/contrib/extensions/browser/extensions.web.contribution";
( (Registry.as(EditorExtensions.EditorPane))).registerEditorPane(EditorPaneDescriptor.create(RuntimeExtensionsEditor, RuntimeExtensionsEditor.ID, ( localizeWithPath(_moduleId, 0, "Running Extensions"))), [( (new SyncDescriptor(RuntimeExtensionsInput)))]);
